/*
  One Tooth World — cart page extras (PRD 8.6).
  Discount code: nothing is validated here. The code is appended to the checkout URL as ?discount=CODE,
  so Shopify applies it at checkout. The cart section is re-rendered by otw-cart.js, so handlers are delegated.
*/
const OTW = (window.OTW = window.OTW || {});
const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

let code = '';

function checkoutUrl(value) {
  const base = `${root()}checkout`;
  return value ? `${base}?discount=${encodeURIComponent(value)}` : base;
}

function goToCheckout(value) {
  // The order note is saved on change; flush it so it survives the redirect
  const note = document.querySelector('[data-otw-note]');
  const save = note
    ? fetch(`${root()}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value }),
      }).catch(() => {})
    : Promise.resolve();
  save.then(() => (window.location.href = checkoutUrl(value)));
}

document.addEventListener('input', (event) => {
  const input = event.target.closest?.('[data-otw-discount-input]');
  if (input) code = input.value.trim();
});

document.addEventListener('click', (event) => {
  const apply = event.target.closest?.('[data-otw-discount-apply]');
  if (!apply) return;
  const input = apply.closest('[data-otw-discount]').querySelector('[data-otw-discount-input]');
  code = input.value.trim();
  const note = apply.closest('[data-otw-discount]').querySelector('[data-otw-discount-note]');
  if (!code) {
    input.focus();
    return;
  }
  note.textContent = (OTW.strings && OTW.strings.discountSaved) || 'Applied at checkout';
  OTW.toast?.((OTW.strings && OTW.strings.discountSaved) || 'Applied at checkout', { icon: false });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' || !event.target.matches?.('[data-otw-discount-input]')) return;
  event.preventDefault();
  event.target.closest('[data-otw-discount]').querySelector('[data-otw-discount-apply]').click();
});

/* The section is swapped after every cart change; put the typed code back */
OTW.on?.('cart:updated', () => {
  requestAnimationFrame(() => {
    const input = document.querySelector('[data-otw-discount-input]');
    if (input && code) input.value = code;
  });
});

document.addEventListener('submit', (event) => {
  const form = event.target.closest?.('[data-otw-checkout-form]');
  if (!form || !code) return;
  event.preventDefault();
  goToCheckout(code);
});
